module.exports = __webpack_public_path__ + "img/tree-02-a-leaves.8523d942.png";